export default __webpack_public_path__ + "static/media/lb.9ba34616.svg";